import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';



export default function Running() {
    const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    if (nodeMode === "development") {
      var baseUrl = backendLocalApiUrl;
    } else {
      baseUrl = backendLiveApiUrl;
    }

    const [challenge, setchallenge] = useState()

    const Allchallenge = async () => {
        const access_token = localStorage.getItem('token')
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl+`challange/running_challange`, { headers })
            .then((res) => {
                setchallenge(res.data)
            })
    }

    // DataTable removed — it conflicts with React's virtual DOM and causes the table to go blank on column click

    const CancelGame = async (id) => {
        const confirm = window.confirm("are you sure to cancel")

        if (confirm == true) {
            const access_token = localStorage.getItem('token')
            const headers = {
                Authorization: `Bearer ${access_token}`

            }
            axios.patch(baseUrl+`challange/Cancel/${id}`, { Cancelled_by: access_token }, { headers })
                .then((res) => {
                    Allchallenge()
                })
        }
        else {
            window.alert("sorry try again")
        }
    }

    const [checkingId, setCheckingId] = useState(null);

    const checkAutoResult = async (gameId, roomCode) => {
        if (!roomCode) {
            alert('इस मैच में Room Code मौजूद नहीं है।');
            return;
        }
        setCheckingId(gameId);
        try {
            const access_token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${access_token}` };
            const res = await axios.get(baseUrl + `api/v1/ludoroom/check/${gameId}`, { headers });
            if (res.data && res.data.success) {
                alert(`✅ Auto Result Success: ${res.data.message || 'Match verified & settled!'}\nWinner: ${res.data.winner || 'Updated'}`);
                Allchallenge();
            } else {
                alert(`ℹ️ LudoRoom Status: ${res.data.message || 'Result not yet finalized on LudoRoom'}`);
            }
        } catch (err) {
            const msg = err.response?.data?.message || err.message;
            alert(`❌ Error: ${msg}`);
        } finally {
            setCheckingId(null);
        }
    };

    const dateFormat=(e)=>{
      
  const date = new Date(e); 
const newDate = date.toLocaleString('default', { month: 'long',day:'numeric',hour:'numeric',hour12:true,minute:'numeric' });
return newDate;
  }
    useEffect(() => {
        Allchallenge();
        const pollTimer = setInterval(() => {
            Allchallenge();
        }, 4000);
        const handleFocus = () => {
            Allchallenge();
        };
        window.addEventListener('focus', handleFocus);
        return () => {
            clearInterval(pollTimer);
            window.removeEventListener('focus', handleFocus);
        };
    }, [])

    if (challenge == undefined) {
        return null
    }

   

    return (
        <>
            {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
            <div className="row ">
                <div className="col-12 grid-margin">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">RUNNING CHALLENGES</h4>
                            <div className="table-responsive">
                                <table className="table" >
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th> ID</th>
                                            <th> Creator</th>
                                            <th> Accepter</th>
                                            <th> Amount </th>
                                            <th> Status </th>
                                            <th> Game Type </th>
                                            <th>Date</th>
                                            <th> Action </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {challenge && challenge.map((game, key) => (
                                            <tr key={key}>
                                                <td>{key + 1}</td>
                                                <td>{game._id}</td>
                                                <td>
                                                    <span className="pl-2 ">{game.Created_by?.Name || "Unknown"}</span>
                                                </td>
                                                
                                                <td>
                                                    <span className="pl-2">{game.Accepted_By?game.Accepted_By.Name:null}</span>
                                                </td>
                                                <td>{game.Game_Ammount}</td>
                                                <td className='text-primary font-weight-bold'>{game.Status}</td>
                                                <td>{game.Game_type}</td>
                                                <td>{dateFormat(game.createdAt).split(',')[0]} </td>
                                                <td>
                                                    <Link type='button' className="btn btn-primary mx-1" to={`/view/${game._id}`}>View</Link>
                                                    <button
                                                        type="button"
                                                        className="btn btn-info mx-1"
                                                        onClick={() => checkAutoResult(game._id, game.Room_code)}
                                                        disabled={checkingId === game._id || !game.Room_code}
                                                        title="Check LudoRoom Result"
                                                    >
                                                        {checkingId === game._id ? "Checking..." : "⚡ Auto Result"}
                                                    </button>
                                                    {/* {game.Status != "cancelled" && game.Status != "completed" && game.Status != "conflict" && <button type='button' className="btn  mx-1 btn-danger" onClick={() => CancelGame(game._id)}>Cancel</button>} */}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
